import {
  Alert,
  AlertIcon,
  BoxProps,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";

type ComplianceWarningType = "eeoc" | "subjectivity";

interface ComplianceWarningProps extends BoxProps {
  type: ComplianceWarningType;
  loading?: boolean;
}

const BOILERPLATE_MESSAGES: Record<ComplianceWarningType, string> = {
  eeoc: "These questions may inquire about or reveal information related to a protected class under EEOC guidelines.",
  subjectivity:
    "The evaluation criteria for this question may be difficult to assess objectively from the candidate's responses.",
};

export const ComplianceWarning: React.FC<ComplianceWarningProps> = ({
  type,
  loading = false,
  ...boxProps
}) => {
  if (loading) {
    return (
      <Flex align="center" gap={2} py={2} {...boxProps}>
        <Spinner size="sm" color="gray.400" />
        <Text fontSize="sm" color="gray.500">
          Checking compliance...
        </Text>
      </Flex>
    );
  }

  const status = type === "eeoc" ? "warning" : "error";
  const colors = {
    backgroundColor: type === "eeoc" ? "yellow.100" : "red.100",
    borderColor: type === "eeoc" ? "yellow.200" : "red.200",
    iconColor: type === "eeoc" ? "yellow.700" : "red.400",
  };
  return (
    <Alert
      status={status}
      mt={2}
      borderRadius="6px"
      backgroundColor={colors.backgroundColor}
      borderColor={colors.borderColor}
      {...boxProps}
    >
      <AlertIcon color={colors.iconColor} />
      <Text fontSize="sm">{BOILERPLATE_MESSAGES[type]}</Text>
    </Alert>
  );
};
